import { render, staticRenderFns } from "./ShipPending.vue?vue&type=template&id=7be03ba6&scoped=true&"
import script from "./ShipPending.vue?vue&type=script&lang=js&"
export * from "./ShipPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be03ba6",
  null
  
)

export default component.exports